import React from "react"
import { useTranslation } from "react-i18next"

import { ObligationList } from "~/api/types/ObligationList"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { formatDateNew } from "~/helpers/formatDate"

import styles from "./index.module.css"

export const Item: React.FC<ObligationList> = ({
  coupon,
  dateOfAdmission,
  issueVolume,
  redemptionDate,
  stateRegNumber,
}) => {
  const { t } = useTranslation()

  return (
    <Card className={styles.Wrapper} hasHover>
      <Heading className={styles.StateRegNumber} like="h4">
        <Raw html={stateRegNumber} />
      </Heading>
      <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.Title") }} />

      <div className={styles.Detail}>
        <div className={styles.DetailItem}>
          <Heading as="div" className={styles.DetailTitle} like="h4">
            <Raw html={coupon} />
            &nbsp;%
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.Coupon") }} />
        </div>

        <div className={styles.DetailItem}>
          <Heading as="div" className={styles.DetailTitle} like="h4">
            {formatDateNew(dateOfAdmission, "dd.MM.yyyy")}
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.DateOfAdmission") }} />
        </div>

        <div className={styles.DetailItem}>
          <Heading as="div" className={styles.DetailTitle} like="h4">
            <Raw html={issueVolume} />
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.IssueVolume") }} />
        </div>

        <div className={styles.DetailItem}>
          <Heading as="div" className={styles.DetailTitle} like="h4">
            {formatDateNew(redemptionDate, "dd.MM.yyyy")}
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.RedemptionDate") }} />
        </div>
      </div>
    </Card>
  )
}
